/* eslint-disable consistent-return */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { get } from 'lodash';

import AddInternationalPayeeForm from '../AddInternationalPayeeForm';
import {
	accountsForAddPayeePropTypes,
	addPayeeFormPropTypes,
	linkAccountDetailsPropTypes,
} from '../../states/addPayee/propTypes';
import { getAccountsForAddPayee } from '../../../states/accounts/selectors';
import { withScrollTop } from '../../../containers/withScrollTop';
import {
	showAllErrors,
	initValidationForAddPayee,
	initValidationForAddInternationalPayee,
	removeKey,
} from '../../../states/validation/actions';
import { isSpecificFormValid } from '../../../states/validation/selectors';
import {
	submitAddPayeeRequest,
	createBeneficiaryEvent,
	beneficiaryEventsFailure,
	initAddPayeeForm,
	submitInternationalAddPayeeRequest,
	setGenericError,
} from '../../states/addPayee/actions';
import { unsetAccountError } from '../../../states/payees/actions';

import {
	getLinkAccountDetails,
	getAddPayeeFormDetails,
	getFromAccountId,
	isPaymentFlow,
	getAddMultiplePaymentsFlag,
	getSelectedPaymentId,
	isFromChapsPayment,
	getSourceAccountId,
	isValidChapsCharsFormat,
	getAccountNameServicesError,
} from '../../states/addPayee/selectors';
import { getBankId, getClientContext, getToken } from '../../../states/session/selectors';
import { getApiBaseUrlPaas } from '../../../states/envConfig/selectors';
import {
	TYPE_BACS_CREDIT,
	TYPE_IFT,
	TYPE_BACS_DEBIT,
	TYPE_FASTER_PAYMENTS,
	TYPE_DOMESTIC_PAYEE,
	TYPE_IFT_PAYEE,
	TYPE_CHAPS,
	copCustomerType,
} from '../../../config/';
import AddPayeeFormWithTrusted from '../AddPayeeForm/AddPayeeFormWithTrusted';
import COP from '../../../cop/components/App/App';
import { pages, goBackPage, handleGoToPayments } from '../../../states/page/actions';
import { getUserId } from '../../../states/user/selectors';
import { getIsDuplicatePayeeSubmitted } from '../../../states/payees/selectors';
import { DuplicatePayeeModal } from '../../../sharedComponents/Notifications/DuplicatePayeeModal';
import { removeDuplicatePayeeSubmitted } from '../../../states/payees/actions';
import { getConfirmationOfPayeeCopCheckError, getConfirmationOfPayeeCopCheckSuccess } from '../../../utils/payeeUtils';

const mapDispatch = (dispatch, props) => ({
	showAllErrors: () => dispatch(showAllErrors(props.id)),
	submitAddPayeeRequest: ({ payeeDetails, account, copDetails }) =>
		dispatch(submitAddPayeeRequest({ id: props.id, payeeDetails, account, copDetails })),
	initValidationForAddPayee: () => dispatch(initValidationForAddPayee()),
	initValidationForAddInternationalPayee: (isPaymentFlow) =>
		dispatch(initValidationForAddInternationalPayee(isPaymentFlow)),
	beneficiaryEventsFailure: () => dispatch(beneficiaryEventsFailure()),
	initAddPayeeForm: (initialValues) => dispatch(initAddPayeeForm(props.id, initialValues)),
	submitInternationalAddPayeeRequest: (addPayeeForm, linkAccountDetails) =>
		dispatch(submitInternationalAddPayeeRequest(props.id, addPayeeForm, linkAccountDetails)),
	removeKey: (idObj) => dispatch(removeKey(idObj)),
	setGenericError: (errorCode) => dispatch(setGenericError(errorCode)),
	unsetAccountError: () => dispatch(unsetAccountError()),
	removeDuplicatePayeeSubmitted: () => dispatch(removeDuplicatePayeeSubmitted()),
	goBackPage: () => dispatch(goBackPage()),
	goToPayments: () => dispatch(handleGoToPayments()),
});

const mapState = (state, props) => ({
	accountsForAddPayee: getAccountsForAddPayee(state),
	formValid: isSpecificFormValid(state, props.id),
	linkAccountDetails: getLinkAccountDetails(state, props.accountsForAddPayee),
	sourceAccountId: getSourceAccountId(state),
	bankId: getBankId(state),
	addPayeeForm: getAddPayeeFormDetails(state),
	clientContext: getClientContext(state),
	apiBaseUrlPaas: getApiBaseUrlPaas(state),
	fromAccountId: getFromAccountId(state),
	isPaymentFlow: isPaymentFlow(state),
	isNotToAccountSelection: getAddMultiplePaymentsFlag(state),
	selectedPaymentId: getSelectedPaymentId(state),
	isFromChapsPayment: isFromChapsPayment(props.paymentTypeOrPayeeType),
	token: getToken(state),
	isValidChapsCharsFormat: isValidChapsCharsFormat(state),
	customerId: getUserId(state),
	isDuplicatePayeeSubmitted: getIsDuplicatePayeeSubmitted(state),
	hasAccountNameServicesError: getAccountNameServicesError(state),
});
//TODO - the way this has been written we re-render the component on every keypress - needs to be refactored!
export class AddNewPayeeLandingPage extends Component {
	constructor(props) {
		super(props);
		this.handleAddPayeeSubmit = this.handleAddPayeeSubmit.bind(this);
		this.handleAddInternationalPayeeSubmit = this.handleAddInternationalPayeeSubmit.bind(this);
		this.handleCOPSuccess = this.handleCOPSuccess.bind(this);
		this.handleCOPCancel = this.handleCOPCancel.bind(this);
		this.handleCOPEdit = this.handleCOPEdit.bind(this);
		this.handleDuplicatePayeeModalOK = this.handleDuplicatePayeeModalOK.bind(this);

		this.state = { COPCheck: false };
	}
	componentWillMount() {
		const {
			id,
			initValidationForAddPayee,
			initAddPayeeForm,
			fromAccountId = '',
			initValidationForAddInternationalPayee,
			isPaymentFlow,
			isFromChapsPayment,
			sourceAccountId,
		} = this.props;
		const accountId = isPaymentFlow ? fromAccountId : sourceAccountId;
		initAddPayeeForm({ linkAccount: accountId, chapsPaymentsEnable: isFromChapsPayment, singleUse: isPaymentFlow });
		if (id === 'addInternationalPayee') return initValidationForAddInternationalPayee(isPaymentFlow);
		initValidationForAddPayee();
	}
	componentWillUnmount() {
		const { removeKey, id } = this.props;
		removeKey({ id });
	}
	handleAddPayeeSubmit() {
		const { showAllErrors, formValid, isValidChapsCharsFormat, setGenericError } = this.props;
		if (!formValid) return showAllErrors();
		if (!isValidChapsCharsFormat) {
			window.scrollTo(0, 0);
			return setGenericError('incorrectDetailsForChaps');
		}
		this.setState({ COPCheck: true });
	}

	handleCOPSuccess(copDetails = {}) {
		const {
			submitAddPayeeRequest,
			addPayeeForm,
			linkAccountDetails,
			bankId,
			apiBaseUrlPaas,
			clientContext,
			beneficiaryEventsFailure,
			token,
			goToPayments,
			hasAccountNameServicesError,
		} = this.props;
		const copResult = hasAccountNameServicesError
			? getConfirmationOfPayeeCopCheckError()
			: getConfirmationOfPayeeCopCheckSuccess(get(copDetails, 'result'));
		const copPayload = {
			payeeName: copDetails.payeeName || get(addPayeeForm, 'name', ''),
			payeeType: copDetails.payeeType || get(addPayeeForm, 'copType'),
			result: {
				...copResult,
			},
		};
		new Promise((resolve) =>
			resolve(
				submitAddPayeeRequest({
					payeeDetails: addPayeeForm,
					account: linkAccountDetails,
					copDetails: copPayload,
				})
			)
		).then((response) => {
			createBeneficiaryEvent({
				bankId,
				apiBaseUrlPaas,
				addPayeeForm,
				clientContext,
				beneficiaryEventsFailure,
				token,
			});
			if (!get(response, 'hasError')) goToPayments();
		});
	}

	handleCOPCancel() {
		this.setState({ COPCheck: false });
	}

	handleCOPEdit() {
		this.props.unsetAccountError();
		this.setState({ COPCheck: false }, this.props.goToEditPayeePage);
	}

	handleAddInternationalPayeeSubmit() {
		const { showAllErrors, formValid, addPayeeForm, linkAccountDetails, submitInternationalAddPayeeRequest } =
			this.props;
		showAllErrors();
		if (formValid) {
			submitInternationalAddPayeeRequest(addPayeeForm, linkAccountDetails);
		}
	}
	handleDuplicatePayeeModalOK() {
		this.props.removeDuplicatePayeeSubmitted();
		this.setState({ COPCheck: false });
	}
	render() {
		const { addPayeeForm, copCheckTriggered, customerId, isDuplicatePayeeSubmitted, goBackPage, sessionCOPChecks } =
			this.props;

		const { showLoader, copTryCount, COPCheck } = this.state;

		if (isDuplicatePayeeSubmitted) {
			return (
				<DuplicatePayeeModal
					handleOK={this.handleDuplicatePayeeModalOK}
					handleClose={this.handleDuplicatePayeeModalOK}
				/>
			);
		}

		if (showLoader) return <Loader isOpen />;
		if (COPCheck) {
			const copDetails = {
				accountName: addPayeeForm.name,
				accountNumber: addPayeeForm.accountNumber,
				sortCode: addPayeeForm.sortCode,
				accountType: addPayeeForm.copType,
				reference: addPayeeForm.reference,
				customerId: customerId,
				customerType: copCustomerType.Business,
				page: pages.COP.MakeMatch,
			};

			return (
				<COP
					copCheckTriggered={copCheckTriggered}
					cop={copDetails}
					handleComplete={this.handleCOPSuccess}
					handleCancel={goBackPage ? goBackPage : this.handleCOPCancel}
					handleEdit={this.handleCOPEdit}
					initStore={false}
					isPayeeSaved={true}
					isSingleUse={addPayeeForm.singleUse}
					sessionCOPChecks={sessionCOPChecks}
				/>
			);
		}

		const { id, accountsForAddPayee, paymentTypeOrPayeeType, isFromChapsPayment } = this.props;
		switch (paymentTypeOrPayeeType) {
			case TYPE_BACS_CREDIT:
			case TYPE_BACS_DEBIT:
			case TYPE_FASTER_PAYMENTS:
			case TYPE_DOMESTIC_PAYEE:
			case TYPE_CHAPS:
				return (
					<AddPayeeFormWithTrusted
						id={id}
						accountsForAddPayee={accountsForAddPayee}
						handleAddPayeeSubmit={this.handleAddPayeeSubmit}
						isFromChapsPayment={isFromChapsPayment}
					/>
				);

			case TYPE_IFT:
			case TYPE_IFT_PAYEE:
				return (
					<AddInternationalPayeeForm
						id={id}
						accountsForAddPayee={accountsForAddPayee}
						handleAddInternationalPayeeSubmit={this.handleAddInternationalPayeeSubmit}
					/>
				);
			default:
				break;
		}
		return null;
	}
}

AddNewPayeeLandingPage.propTypes = {
	id: PropTypes.string.isRequired,
	accountsForAddPayee: PropTypes.arrayOf(PropTypes.shape(accountsForAddPayeePropTypes)).isRequired,
	showAllErrors: PropTypes.func.isRequired,
	initAddPayeeForm: PropTypes.func.isRequired,
	initValidationForAddPayee: PropTypes.func.isRequired,
	initValidationForAddInternationalPayee: PropTypes.func.isRequired,
	formValid: PropTypes.bool.isRequired,
	isPaymentFlow: PropTypes.bool.isRequired,
	bankId: PropTypes.string.isRequired,
	submitAddPayeeRequest: PropTypes.func.isRequired,
	addPayeeForm: PropTypes.shape(addPayeeFormPropTypes).isRequired,
	linkAccountDetails: PropTypes.shape(linkAccountDetailsPropTypes).isRequired,
	clientContext: PropTypes.shape({}).isRequired,
	apiBaseUrlPaas: PropTypes.string.isRequired,
	beneficiaryEventsFailure: PropTypes.func.isRequired,
	paymentTypeOrPayeeType: PropTypes.string.isRequired,
	fromAccountId: PropTypes.string.isRequired,
	isFromChapsPayment: PropTypes.bool.isRequired,
	token: PropTypes.string.isRequired,
	submitInternationalAddPayeeRequest: PropTypes.func.isRequired,
	removeKey: PropTypes.func.isRequired,
	sourceAccountId: PropTypes.string.isRequired,
	isValidChapsCharsFormat: PropTypes.bool.isRequired,
	setGenericError: PropTypes.func.isRequired,
	isPayeeSaved: PropTypes.bool,
	isSingleUse: PropTypes.bool,
	copCheckTriggered: PropTypes.func,
	sessionCOPChecks: PropTypes.object,
};

export default compose(connect(mapState, mapDispatch), withScrollTop)(AddNewPayeeLandingPage);
